import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext({ settings: {}, loading: true, refresh: () => {} });

const FALLBACK = {
  brand_name: "Trilogy Sports & Fitness",
  tagline: "Mental. Physical. Spiritual.",
  exercise_booking_url: "https://train.trilogyfitpt.com",
  exercise_packages_url: "https://train.trilogyfitpt.com",
  client_portal_url: "https://train.trilogyfitpt.com",
  app_store_url: "https://apps.apple.com/",
  google_play_url: "https://play.google.com/store",
  social: {},
};

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/public/settings");
      setSettings({ ...FALLBACK, ...data });
    } catch (e) {
      setSettings(FALLBACK);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
